import React from "react";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import commitmentSlice from "../../../state/slices/commitmentSlice";
import TextArea from "../../materialCommitment/commitment/TextArea";

const BackgroundInfoContainer = ({ backgroundDescriptionRef }) => {
  const { language, commitment, validators } = useSelector(state => state);
  const dispatch = useDispatch();
  const { changeBackgroundInfo } = bindActionCreators(
    commitmentSlice.actions,
    dispatch
  );

  const changeBackgroundHandler = (language, content) => {
    changeBackgroundInfo({ language: language, content: content });
  };

  return (
    <div className="border-bottom">
      <div ref={backgroundDescriptionRef}>
        <TextArea
          commitment={commitment}
          target={`backgroundInformation_${language}`}
          title={"sit.commitment.backgroundInfo.871646"}
          maxLength={3500}
          toolTip={"tooltip.commitmentBackgroundInfo.871646"}
          reference={backgroundDescriptionRef}
          validated={validators.background}
          setValidated={() => {}}
          handleChange={changeBackgroundHandler}
          language={language}
          useTooltipLanguageOverride
        />
      </div>
    </div>
  );
};

export default BackgroundInfoContainer;



// WEBPACK FOOTER //
// ./src/components/circularEconomyCommitment/commitment/BackgroundInfoContainer.jsx